import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Kelowna.jpg';

const KelownaPage = () => (
  <CityPage
    city="Kelowna"
    region="British Columbia"
    country="Canada"
    countryCode="CA"
    routePath="/kelowna"
    currentPage="KelownaPage"
    image={image}
    imageAlt="Boat rentals on Okanagan Lake in Kelowna, BC"
    intro="Kelowna sits right on Okanagan Lake — the heart of BC's boating scene. From wake boats and Sea-Doos to family pontoons and fishing boats, WetRentals connects you directly with local hosts so you can spend the day on one of the most beautiful lakes in Canada."
    sections={[
      {
        heading: 'Where to boat in Kelowna',
        body:
          "Okanagan Lake runs more than 130 km from Vernon in the north to Penticton in the south. Popular launches around Kelowna include Cook Road, Boyce-Gyro Beach, Manteo and the downtown waterfront. WetRentals hosts deliver across West Kelowna, Lake Country and Peachland.",
      },
      {
        heading: 'What you can rent in Kelowna',
        body:
          'Wake and ski boats for surfing and wakeboarding, pontoon boats for parties and family days, Sea-Doos and Jet Skis, fishing boats for kokanee and rainbow trout, and kayaks/paddleboards for quieter coves.',
      },
      {
        heading: 'Why book with WetRentals in Kelowna',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Kelowna%2C%20British%20Columbia%2C%20Canada&bounds=50.03954311%2C-119.38204554%2C49.75619913%2C-119.70779954&mapSearch=true"
    searchLabel="Browse all boat rentals in Kelowna"
  />
);

export default KelownaPage;
